import React from 'react'
import { whiteCard } from '../common/cssclasses'
import { useTranslate } from './TranslationText'
import { Link } from 'react-router-dom';

export default function JudgeCard({ judge }) {
    const { translate } = useTranslate();
    return (
        <div className={whiteCard}>
            <div className='w-100 border-15 mb-main' style={{ aspectRatio: 1, overflow: 'hidden' }}>
                <img src={judge?.imagePath} className='w-100 border-15 mb-main' />
            </div>
            <div className='horseCardTitle mb-2 fw-bold'>
                {judge?.name}
            </div>
            <div className="row ">
                {!!judge?.phoneNumber &&
                    <Link to={`tel:${judge?.phoneNumber}`} className="col-12 mb-1">
                        <div className="horseCardDescription fw-bold">
                            <i className="fa fa-phone C89C66 me-1"></i> {judge?.phoneNumber}
                        </div>
                      
                    </Link>
                }
                {!!judge?.email &&
                <Link to={`mailto:${judge?.email}`} className="col-12">
                    <div className="horseCardDescription fw-bold">
                        <i className="fa fa-envelope C89C66 me-1"></i>{judge?.email}</div>
                </Link>
                }


            </div>
        </div>
    )
}
